@if (rubric) {
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-form-title model="User Skill Levels"></app-form-title>
		<nz-table #skillTable [nzData]="skills" [nzLoading]="loading$ | async">
			<thead>
				<tr>
					<th>Skill</th>
					<th>Rubric Level</th>
				</tr>
			</thead>
			<tbody>
				@for (skill of skills; track skill) {
					<tr>
						<td>{{ skill.label }}</td>
						<td>
							<app-rubric-level-dropdown-field
								[fg]="form"
								[formGroupOrControlName]="skill.code"
								[label]="''"
								[noLabel]="true"
								[multiple]="false"
								[rubric]="rubric"
							></app-rubric-level-dropdown-field>
						</td>
					</tr>
				}
			</tbody>
		</nz-table>

		<div class="buttons">
			<button
				nz-button
				nzType="primary"
				type="submit"
				[disabled]="form.invalid || !selectedUserCognitoUuid || !rubric.code"
			>
				Submit
			</button>
			<button nz-button type="button" (click)="clear()">Clear</button>
		</div>
	</form>
}
